module.exports = __webpack_public_path__ + "static/media/1.aa3a7da2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank/zsbank/1.png
// module id = 2699
// module chunks = 2